import {
  GET_DASHBOARD,
  GET_DASHBOARD_ERROR,
  GET_DASHBOARD_SUCCESS,
} from "./actionTypes";

export const getDashboard = (request) => {
  return {
    type: GET_DASHBOARD,
    payload: { request },
  };
};

export const getDashboardSuccess = (data) => {
  return {
    type: GET_DASHBOARD_SUCCESS,
    payload: data,
  };
};

export const getDashboardError = (message) => {
  return {
    type: GET_DASHBOARD_ERROR,
    payload: message,
  };
};
